import React from 'react';
import { CloudIcon, CpuChipIcon, LinkIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';

const features = [
  {
    name: '真正的无服务器',
    description: '基于 Cloudflare Workers 构建，不需要管理服务器，也不需要担心运维问题。',
    icon: CloudIcon,
  },
  {
    name: '智能但简单',
    description: '用简单的规则实现智能的记忆管理，而不是堆磐复杂的功能。',
    icon: CpuChipIcon,
  },
  {
    name: '连接一切',
    description: '支持双向链接，让你的想法自然连接，形成知识网络。',
    icon: LinkIcon,
  },
  {
    name: '隐私优先',
    description: '数据完全在你的控制之下，我们不会分析或共享你的记忆。',
    icon: ShieldCheckIcon,
  },
];

export function Features() {
  return (
    <div className="bg-gray-50 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-semibold leading-7 text-primary-600">
            为什么选择 MemPalace
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            简单，但足够好用
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            我们不相信"颠覆性"这样的词，只是想把记忆管理这件事做得更好一点。
          </p>
        </div>
        
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-4">
            {features.map((feature) => (
              <div key={feature.name} className="flex flex-col">
                <dt className="flex items-center gap-x-3 text-base font-semibold leading-7 text-gray-900">
                  <feature.icon className="h-5 w-5 flex-none text-primary-600" aria-hidden="true" />
                  {feature.name}
                </dt>
                <dd className="mt-4 flex flex-auto flex-col text-base leading-7 text-gray-600">
                  <p className="flex-auto">{feature.description}</p>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
